const germanWords = [
    "aber", "auf", "aus", "bei", "bringen", "gebracht", "das", "dem", "den", "der",
    "des", "die", "ein", "eine", "einen", "es", "funktioniert", "ich", "ist", "mit",
    "muss", "muessen", "mussen", "m\u00f6chte", "nicht", "noch", "ob", "oder", "pruefen",
    "pr\u00fcfen", "stand", "stuehle", "st\u00fchle", "text", "ueberpruefe", "\u00fcberpr\u00fcfe", "und",
    "werden", "wie", "zum", "zur", "zwei"
];

const englishWords = [
    "and", "are", "be", "bottle", "bucket", "cleaned", "comment", "comments", "found",
    "have", "is", "needs", "noticed", "out", "painted", "should", "stand", "taken",
    "text", "that", "the", "think", "to", "trash", "wall", "way", "with"
];

const countLanguageWords = (value, words) => words.reduce((result, word) => {
    const pattern = new RegExp(`(^|\\s)${ word }(\\s|$)`, "i");

    return result + (pattern.test(value) ? 1 : 0);
}, 0);

export const detectGermanEnglishTextLanguage = (text) => {
    const value = String(text || "")
        .toLowerCase()
        .replace(/[.,!?;:()[\]{}"']/g, " ");
    let germanScore = countLanguageWords(value, germanWords),
        englishScore = countLanguageWords(value, englishWords);

    if (/[\u00e4\u00f6\u00fc\u00df]/i.test(value)) germanScore += 3;
    if (/\b(the|and|to|be|needs|cleaned|taken|painted|think|should|found|noticed)\b/i.test(value)) {
        englishScore += 2;
    }

    if (germanScore >= englishScore + 2) return "de";
    if (englishScore >= germanScore + 2) return "en";

    return null;
};
